export enum WorkflowTemplateSelectionActionType {
  RESET_STATE = 'WORKFLOW_TEMPLATE_SELECTION_RESET_STATE',
  SELECT_WORKFLOW_TEMPLATE = 'WORKFLOW_TEMPLATE_SELECTION_SELECT_WORKFLOW_TEMPLATE',
  SELECT_WORKFLOW_TEMPLATE_VERSION = 'WORKFLOW_TEMPLATE_SELECTION_SELECT_WORKFLOW_TEMPLATE_VERSION',
  UPDATE_ROOT_FOLDER = 'WORKFLOW_TEMPLATE_SELECTION_UPDATE_ROOT_FOLDER',
}

export interface ResetStateAction {
  type: WorkflowTemplateSelectionActionType.RESET_STATE;
}
export function resetState(): ResetStateAction {
  return {
    type: WorkflowTemplateSelectionActionType.RESET_STATE,
  };
}

export interface SelectWorkflowTemplateAction {
  type: WorkflowTemplateSelectionActionType.SELECT_WORKFLOW_TEMPLATE;
  workflowTemplateId: string;
}
export function selectWorkflowTemplate(workflowTemplateId: string): SelectWorkflowTemplateAction {
  return {
    type: WorkflowTemplateSelectionActionType.SELECT_WORKFLOW_TEMPLATE,
    workflowTemplateId,
  };
}

export interface SelectWorkflowTemplateVersionAction {
  type: WorkflowTemplateSelectionActionType.SELECT_WORKFLOW_TEMPLATE_VERSION;
  workflowTemplateId: string;
  workflowTemplateVersionId: string;
}
export function selectWorkflowTemplateVersion(
  workflowTemplateId: string,
  workflowTemplateVersionId: string
): SelectWorkflowTemplateVersionAction {
  return {
    type: WorkflowTemplateSelectionActionType.SELECT_WORKFLOW_TEMPLATE_VERSION,
    workflowTemplateId,
    workflowTemplateVersionId,
  };
}

export interface UpdateRootFolderAction {
  type: WorkflowTemplateSelectionActionType.UPDATE_ROOT_FOLDER;
  rootFolderId: string;
}
export function updateRootFolder(rootFolderId: string): UpdateRootFolderAction {
  return {
    type: WorkflowTemplateSelectionActionType.UPDATE_ROOT_FOLDER,
    rootFolderId,
  };
}

export type WorkflowTemplateSelectionAction =
  | ResetStateAction
  | SelectWorkflowTemplateAction
  | SelectWorkflowTemplateVersionAction
  | UpdateRootFolderAction;
